import { Card, Col, Divider, Empty, Image, Row, Tag, Typography } from 'antd';
import { useMenu } from '../context/MenuContext';

const { Title, Text } = Typography;

export default function PublicMenu() {
  const { menu } = useMenu();

  return (
    <div style={{ maxWidth: 680, margin: '0 auto', padding: '24px 16px' }}>
      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <Title level={2}>{menu.restaurantName}</Title>
        {menu.description && <Text type="secondary">{menu.description}</Text>}
      </div>

      {menu.categories.length === 0 || menu.items.length === 0
        ? <Empty description="No menu items yet." />
        : menu.categories
            .sort((a, b) => a.sortOrder - b.sortOrder)
            .map(cat => {
              const items = menu.items.filter(i => i.category === cat.id && i.available);
              if (items.length === 0) return null;
              return (
                <div key={cat.id} style={{ marginBottom: 32 }}>
                  <Title level={4} style={{ borderBottom: '2px solid #f0f0f0', paddingBottom: 8 }}>{cat.name}</Title>
                  {cat.description && <Text type="secondary">{cat.description}</Text>}
                  <Row gutter={[12, 12]} style={{ marginTop: 12 }}>
                    {items.map(item => (
                      <Col key={item.id} xs={24} sm={12}>
                        <Card
                          size="small"
                          bodyStyle={{ padding: 12 }}
                          cover={item.image ? <Image src={item.image} alt={item.name} height={140} style={{ objectFit: 'cover' }} /> : null}
                        >
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <div style={{ flex: 1 }}>
                              <Text strong>{item.name}</Text>
                              {item.description && <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{item.description}</div>}
                              {item.tags?.length > 0 && (
                                <div style={{ marginTop: 6 }}>
                                  {item.tags.map(t => <Tag key={t} color="blue" style={{ fontSize: 11 }}>{t}</Tag>)}
                                </div>
                              )}
                            </div>
                            <Text strong style={{ whiteSpace: 'nowrap', marginLeft: 8, color: '#1677ff' }}>
                              {menu.currency} {item.price.toFixed(2)}
                            </Text>
                          </div>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                  <Divider />
                </div>
              );
            })
      }
    </div>
  );
}
